<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>开户管理</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
      <el-form-item label="搜索：">
         <el-select v-model="formInline.energyType" placeholder="请选择" size="small" style="width: 120px;"  @change="search">
            <el-option
              v-for="item in energyTypeList"
              :key="item.id"
              :label="item.value"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'">
         <el-select v-model="getJZ" placeholder="请选择" @change="handleNodeClick" size="small">
            <el-option
              v-for="item in treeDate"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
			<el-form-item >
				<el-input placeholder="请输入房间编号"  @keyup.enter.native="search"  v-model="formInline.meterPointName" size="small"></el-input>
			</el-form-item>

      <el-form-item >
      	<el-input placeholder="请输入计量点地址"  @keyup.enter.native="search"  v-model="formInline.meterPoint" size="small"></el-input>
      </el-form-item>


			<el-form-item >
				<el-input placeholder="请输入用户账号"  @keyup.enter.native="search"  v-model="formInline.username" size="small"></el-input>
			</el-form-item>
			<el-form-item >
				<el-input placeholder="请输入手机号码"  @keyup.enter.native="search"  v-model="formInline.phoneNumber" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<prems-button size="small"  type="warning" icon="el-icon-folder-add" perms="account:kf" @click="handleEdit()" label="开户" />
				<el-button size="small" type="success"   style="margin-left: 10px;"  icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
			</el-form-item>
		</el-form>
		<!-- 数据列表 -->

		<el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="listData" :max-height="tableHeight" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" ref="tablelist" stripe >
			<el-table-column align="center" type="index" width="60">
			</el-table-column>
			<el-table-column prop="id" align="center" label="id" width="60">
			</el-table-column>
			<el-table-column prop="meterPointName" label="房间编号"  >
			</el-table-column>
			<el-table-column prop="meterPoint" label="计量点地址"  >
			</el-table-column>

			<el-table-column label="用户账号" show-overflow-tooltip>
				<template slot-scope="scope" v-if="scope.row.appletUserVo">
          <p style="margin: 0;" :key="item.id" v-for="item in scope.row.appletUserVo">
            <el-tag style="margin-bottom: 5px;" size="small" >{{item.username}}</el-tag>
          </p>

				</template>
			</el-table-column>
			<el-table-column  label="手机号码" >
				<template slot-scope="scope" v-if="scope.row.appletUserVo">
					<el-tag  size="small" style="margin-right: 10px; margin-bottom: 5px;" :key="item.id" v-for="item in scope.row.appletUserVo">{{item.phoneNumber}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column  label="余额(元)"  width="120" >
        	<template slot-scope="scope">
            {{scope.row.blance.toFixed(2)}}
          </template>
			</el-table-column>

      <!-- <el-table-column prop="rent" label="租金" v-if="user.departmentId == 59 || user.departmentId == 6" width="120" >
      </el-table-column> -->
      <el-table-column prop="allowance" label="余量(kWh)"  width="120" >

      </el-table-column>

      <el-table-column prop="dayAvgDegree" label="日均用量(kWh)"  width="120" >

      </el-table-column>


			<el-table-column label="修改时间" prop="updateDate" width="180" ></el-table-column>


			<el-table-column align="center" label="操作" width="340">
				<template slot-scope="scope">
					<prems-button size="mini" type="primary"  perms="account:recharge" @click="handleRecharge(scope.$index, scope.row,'1')" label="充值" />
					<!-- 2023.06.25 feat:添加退款权限按钮 -->
					<prems-button size="mini" type="warning"  perms="account:refund" @click="handleRecharge(scope.$index, scope.row,'2')" label="退款" />
					<prems-button size="mini" type="success" icon="el-icon-edit" perms="account:edit" @click="handleEdit(scope.$index, scope.row)" label="编辑" />
					<prems-button size="mini" type="danger" icon="el-icon-delete"  perms="account:delete" @click="deleteInfo(scope.$index, scope.row)" label="删除" />
				</template>
			</el-table-column>
		</el-table>

		<Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage" ></Pagination>
		<el-dialog :title="title" :visible.sync="editFormVisible" @click="closeDialog" width="35%" :close-on-click-modal="false">
      <el-form label-width="80px" :model="editForm" ref="editForm" label-position="left" :rules="rules" >
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="getJZCurr" placeholder="请选择部门" @change="handleNodeClick1" size="small">
              <el-option
                v-for="item in treeDate"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="选择类型" v-if="title == '开户'">
        	<el-select v-model="currType" filterable placeholder="请选择水电类型"   size="small" style="width: 100%;" @change="getNoBindRoolist">
        		<el-option
        		  v-for="item in editEnergyType"
        		  :key="item.id"
        		  :label="item.value"
        		  :value="item.id"
        		  >
        		</el-option>
        	</el-select>
        </el-form-item>


				<el-form-item label="房间编号" v-if="title == '开户'" prop="room">
					<el-select v-model="selectRoom" filterable placeholder="请选择房间编号" @change="getRoomId"  size="small" style="width: 100%;">
						<el-option
						  v-for="item in roomList"
						  :key="item.id"
						  :label="item.meterPointName"
						  :value="item.id"
						  >
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="当前房间" v-if="title == '修改'" >
					<div>{{roomName}}</div>
				</el-form-item>


				<el-form-item label="用户账号" prop="user">
					<el-select v-model="selectUsers" filterable placeholder="请选择用户账号" @change="getUserId"   multiple  size="small" style="width: 100%;" >
						<el-option
						  v-for="item in userData"
						  :key="item.id"
						  :label="item.username"
						  :value="item.id"
						  style="width: 500px;"
						  >
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>


		<el-dialog :title="rtitle" :visible.sync="rechargeFormVisible" width="30%" @click="closeDialog" :close-on-click-modal="false">
			<el-form label-width="120px" :model="reditForm" :rules="crules" ref="reditForm">

				<el-form-item label="房间编号:">
					<div>{{reditForm.meterPointName}}</div>
				</el-form-item>
				<el-form-item label="当前余额:" prop="blance">
					<div>{{reditForm.blance}}</div>
				</el-form-item>

				<el-form-item  label="交易类型">
					<el-select size="small" v-model="reditForm.payType" >
						<el-option v-for="type in payType" :label="type.label" :value="type.value" :key="type.value" v-if="rtitle != '退款' || type.value !='7'"  ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="交易用户">
					<el-radio v-model="reditForm.appletUserid" :label="item.id"   v-for="item in users" :key="item.id">{{item.username}}</el-radio>
				</el-form-item>
				<el-form-item label="充值金额" prop="totalFee" v-if="rtitle == '充值'">
					<el-input size="small" v-model="totalFee" type="number"   placeholder="请输入充值金额" ></el-input>
				</el-form-item>
				<el-form-item label="退款金额" prop="totalFee" v-if="rtitle == '退款'">
					<el-input size="small" v-model="totalFee" type="number" placeholder="请输入退款金额" ></el-input>
				</el-form-item>


				<el-form-item  label="交易备注">
					<el-input
					  type="textarea"
					  autosize
					  placeholder="请输入备注"
					  v-model="reditForm.mark">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="saveLoad" class="title" @click="subRechargeForm('reditForm')">保存</el-button>
			</div>
		</el-dialog>

    <el-dialog title="初始化表码" :visible.sync="initCodeVisible" width="30%"  :close-on-click-modal="false">
    	<el-form label-width="120px" :model="reditForm" :rules="crules" ref="reditForm">

    		<el-form-item label="房间编号:">
    			<div>{{selectRoomName}}</div>
    		</el-form-item>
    		<el-form-item label="计费读数:" >
          <el-row>
            <el-col :span="22"><el-input size="small" v-model="initForm.nowDataValue"></el-input></el-col>
            <el-col :span="2"> <el-tooltip placement="top" effect="light" style="padding: 10px;">
             <div slot="content">
               <p>用户入住时，从输入的计费读数计算表码</p>
             </div>
             <i class="el-icon-warning"></i>
           </el-tooltip></el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="初始化金额:">
    			<el-input size="small" v-model="initForm.balance"></el-input>
    		</el-form-item>








    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="initCodeVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="saveLoad" class="title" @click="initCode">保存</el-button>
    	</div>
    </el-dialog>


	</div>
</template>

<script>
	import { findMeterInfoList ,getDepartmentTerminalInfoLis,getTerminalInfoByDepId,getDayAvgDegree,findMeterInfoListOpenAccount} from '../../api/energyMG'
	import { addMeterInfoAppletUser,poiOpenAccountList,deleMeterInfoAppletUser} from '../../api/userMG.js'
	import { openAccountGetAppletUserList,findMybdMeterInfoList,poiAppletUserList,recharge,refund,findMeterInfoPower,saveAccount } from '../../api/payMG.js'
	import { timestampToTime} from '@/utils/util'
	import PremsButton from "@/views/permission/PreButtom";
	import Pagination from '../../components/Pagination'
  var p1 =[
  	{ value:'2',label:"转账"},
  	{ value:'3',label:"刷卡"},
  	{ value:'7',label:"多还少补"},
  	{ value:'6',label:"其他"},
  	{ value:'1',label:"现金"},
    { value:'4',label:"支付宝"},
    { value:'5',label:"微信"},
  ]
  var p2 = [
  	{ value:'2',label:"转帐发票"},
  	{ value:'3',label:"刷卡发票"},
  	{ value:'7',label:"微信自助"},
  	{ value:'6',label:"其他调整"},
  	{ value:'1',label:"现金发票"},
    { value:'4',label:"支付宝发票"},
    { value:'5',label:"微信发票"},
  ]
	export default{
		data(){
			var validateRoom = (rule, value, callback) => {
				if (this.selectRoom == '') {
					callback(new Error('请选择房间'));
				} else {
					callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (this.totalFee == "") {
					let msg = this.rtitle == '充值'?'请输入充值金额':'请输入退款金额'
					callback(new Error(msg));
				} else {
					if( this.rtitle == '退款'){
						if(this.totalFee > this.reditForm.blance){
							return callback(new Error('退款金额不能大于当前余额'));
						}
					}
					callback();
				}
			};
			var validateUser = (rule, value, callback) => {
				if (this.selectUsers.length == 0) {
					callback(new Error('请选择用户'));
				} else {
					callback();
				}
			};

			return{
        visible:false,
        initForm:{
          nowDataValue:'',
          appletUserIds:"",
          meterId:"",
          balance:"",
        },
        getJZ:"",
        getJZCurr:"",
        treeDate:[],
				loading:false,
				showPage:true,
				loadStatus:false,
        initCodeVisible:false,
        selectRoomName:"",
				title:'开户',
				rtitle:'',
				currid:'',
				formInline:{
					username:'',
					currentPage: 1,
					pageSize: 10,
					sort:'openAccountDate',
					phoneNumber:"",
          meterPoint:"",
					meterPointName:'',
          energyType:15,//默认电的id为15
          terIds:JSON.stringify([]),
				},
				totalFee:"",
				downloadLoadin:false,
				dateData:[],
				listData:[],
				selectRoom:'',
				userData:[],
        energyTypeList:[],
        tableHeight:0,
				editFormVisible:false,
				editForm:{
					meterPointName:'',
				},
				reditForm: {
					meterPointName:"",
					appletUserid:'',
					blance:"",
					id:"",
					payType:'2',
					mark:""
				},
				saveLoad:false,
        billingType:"",
        payType:[],

        editEnergyType:[
          { value:'电',id:15 },
          { value:'水',id:16 }
        ],
        currType:15,
				users:[],
        user:{},
				roomName:"",
				tempUserList:[],
				selectUsers:[],
				roomList:[],
				pageparm:{
					currentPage: 1,
					pageSize:10,
					total: 0
				},
				rechargeFormVisible:false,
				setLoading:false,
				addParam:{
					appletUserId:'',
					meterInfoId:'',
				},
				rules: {
					room: [{
						validator: validateRoom,
						trigger: 'change'
					}],
					user:[{
						validator: validateUser,
						trigger: 'change'
					}]

				},
				crules:{
					totalFee: [{
						validator: validatePass,
						trigger: 'blur'
					}],
				},
        treeLoad:false,
        jzProps:{
        	children: 'deps',
        },

			}

		},
		// 注册组件
		components: {
			Pagination,
			PremsButton
		},
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
		created(){
			this.getJzData()
			this.getUserData()
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if(this.depId == 101){
        this.payType = p1
      }else{
        this.payType = p2
      }
      this.billingType = JSON.parse(sessionStorage.getItem('userdata')).billingType || ''
      this.getJZ = this.user.departmentName
      this.$store.dispatch('getEnergyTypeConfig').then(res => {
        this.energyTypeList = res
      })
		},

		methods: {
				exportdata(){
				this.downloadLoadin = true
				let param = {
					username:this.formInline.username,
					meterPointName:this.formInline.meterPointName,
					phoneNumber:this.formInline.phoneNumber,
          meterPoint:this.formInline.meterPoint
				}
				poiOpenAccountList(param).then(res => {
					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.downloadLoadin = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})
			},

			handleRecharge(index,row,type){
				this.rechargeFormVisible = true

				this.rtitle = type == "1"?'充值':'退款'
				this.reditForm.mark = ''
				if (row != undefined && row != 'undefined') {
					this.reditForm.meterPointName = row.meterPointName
					this.users = row.appletUserVo || []
					this.reditForm.appletUserid = row.appletUserVo[0].id
					this.reditForm.blance = row.blance
					this.reditForm.id = row.id
					this.totalFee = ""
				}
			},

			subRechargeForm(editData) {

				this.$refs[editData].validate(valid => {
					if (valid) {
						this.$confirm('确定执行'+this.rtitle+'操作吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						if( this.rtitle == "充值" ){
							this.rayCheck()
						}else{
							this.brefund();
						}
					})
					} else {
						return false
					}
				})
			},


			//获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						this.treeLoad = false
						if(res.status == 1){
							let arr = []
              this.treeDate = res.data.menuDepList
							this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId)
							resolve(res.data.terIds)
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},

      handleNodeClick(data) {
        this.depId = data
      	this.getDepIds(data)
        if(this.depId == 101){
          this.payType = p1
        }else{
          this.payType = p2
        }
      },
      handleNodeClick1(data) {
        this.depId = data
        this.billingType = this.treeDate.filter(item => item.id == data)[0].billingType
        this.getNoBindRoolist()
      },

      getDepIds(id){
        getTerminalInfoByDepId({
        	depId: id
        }).then(res => {
        	if (res.status == 1) {
        		let arr = []
        		res.data.forEach(item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})
        		this.formInline.terIds = JSON.stringify(arr)

            this.search()
        	} else {
        		this.$message.error(res.msg)
        	}

        })
      },


			getNoBindRoolist() {
        let param = {
          energyType:this.currType,
          departmentId:this.depId
        }
				findMybdMeterInfoList(param).then(res => {
					if (res.status == 1) {
						this.roomList = res.data.dataList
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.editFormVisible = false
					this.loading = false
					this.$message.error('获取没有绑定数据失败，请稍后再试！')
				})
			},
			handleEdit(index,row){
				this.editFormVisible = true
				this.$nextTick(() => {
					this.$refs.editForm.resetFields();
				})
        this.getNoBindRoolist();

				if (row != undefined && row != 'undefined'){
					this.title = '修改'
					this.roomName = row.meterPointName
					this.addParam.meterInfoId  = row.id
					this.selectUsers = row.appletUserVo.map(item => item.id)
          this.addParam.appletUserId = this.selectUsers.join('-')

				}else{
					this.title = '开户'
					this.selectRoom = ''
					this.selectUsers = []
				}

			},
			getUserId(val){
				this.addParam.appletUserId = val.join('-')
        this.initForm.appletUserIds = val.join(',')
			},

			getRoomId( val){
				this.addParam.meterInfoId  = val
        this.selectRoomName = this.roomList.filter(item => item.id == val)[0].meterPointName
        this.initForm.meterId = val
			},


			deleteInfo(index, row){
				this.$confirm('确定要删除吗?', '信息', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(res => {
					deleMeterInfoAppletUser({ meterIds:row.id }).then( res => {
						if( res.status == 1){
							this.$message.success('删除成功！')
							this.getData()
							this.getNoBindRoolist()
						}else{
							this.$message.error(res.msg)
						}
					})
					.catch(err =>{
						 this.$message.error('服务器错误，请稍后再试！')
					})
				})
			},
			getUserData(){
				let param = {
					currentPage: 1,
					pageSize: 9999999,
					username: "",
					meterPointName:"",
					phoneNumber: "",
				}
				openAccountGetAppletUserList().then(res => {

				  if (res.status == 1) {
            this.userData = res.data
				  } else {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  }
				})
				.catch(err => {
				  this.$message.error('获取数据失败，请稍后再试！')
				})
			},

			//开户方法
			submitForm(editData){
				this.$refs[editData].validate(valid => {
					if(valid){
            if(this.title == '修改'){
              this.openAccount()
            }else{
              if(this.billingType == 1){
                //尖峰平谷需要初始化表码
                 this.getMeterCode();
              }else{
                this.openAccount()
              }
            }
					}
				})
			},
      getMeterCode(){
        this.initCodeVisible = true
        this.initForm.balance = ''
        findMeterInfoPower({ meterId:this.addParam.meterInfoId }).then(res => {
          if(res.status == 1){
            this.initForm.nowDataValue = res.data.nowDataValue
          }
        })
      },
      initCode(){
        this.saveLoad = true
        saveAccount(this.initForm).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.openAccount()
          }
        })
      },
      openAccount(){
        this.setLoading = true
        addMeterInfoAppletUser(this.addParam).then(res => {
        	this.setLoading = false
        	this.editFormVisible = false
          this.initCodeVisible = false
        	if( res.status == 1){
        		 this.$message.success('操作成功')
        		 this.getData()
        		 this.getNoBindRoolist()
        	}else{
        		this.$message.error('操作失败')
        	}
        })
        .catch(err => {
          this.$message.error('服务器异常，请稍后再试！')
        })
      },

			search() {
				this.pageparm.currentPage = 1
				this.formInline.currentPage = 1
				this.showPage = false
				this.getData()
				this.$nextTick(()=>{
					this.showPage = true
				})
			},

			getData() {
				this.loading = true
				findMeterInfoListOpenAccount(this.formInline).then(res => {

						if (res.status == 1) {
							// this.listData = res.data.data
              let arr =  res.data.data
              this.getYuliang().then(sRes => {
                this.loading = false
                arr.forEach(item => {
                  sRes.forEach(sitem => {
                    if(item.id == sitem.meterInfoId){
                      item.allowance = sitem.allowance
                      item.dayAvgDegree = sitem.dayAvgDegree
                    }
                  })
                })

                this.listData = arr
              })
							this.pageparm.total = res.data.totalCount
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.loading = false
						this.$message.error('获取数据失败，请稍后再试！')
					})
			},

      getYuliang(){
        return new Promise((resolve,reject) => {
          getDayAvgDegree(this.formInline).then(res => {
            if(res.status == 1){
              resolve(res.data.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },

			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getData()
			},
			//充值
			rayCheck(){
				this.saveLoad = true
				this.rtitle = "充值"
				let param = {
					appletUserId:this.reditForm.appletUserid,
					totalFee:this.totalFee,
					meterInfoId:this.reditForm.id,
					payType:this.reditForm.payType,
					mark:this.reditForm.mark
				}

				recharge(param).then( res => {
					this.saveLoad = false
					if (res.status == 1) {
						this.rechargeFormVisible = false
						this.getData()
						this.$message({
							type: 'success',
							message: '充值成功！'
						})
					} else {
						this.rechargeFormVisible = false
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.rechargeFormVisible = false
					this.saveLoad = false
					this.$message.error('操作失败，请稍后再试！')
				})
			},

				//退款
			brefund(index,row){
				this.saveLoad = true
				this.rtitle = "退款"
				let param = {
					appletUserId:this.reditForm.appletUserid,
					totalFee:this.totalFee,
					meterInfoId:this.reditForm.id,
					payType:this.reditForm.payType,
					mark:this.reditForm.mark
				}
				refund(param).then( res => {
					this.saveLoad = false
					if (res.status == 1) {
						this.rechargeFormVisible = false
						this.getData()
						this.$message({
							type: 'success',
							message: '退款成功！'
						})
					} else {
						this.rechargeFormVisible = false
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.rechargeFormVisible = false
					this.saveLoad = false
					this.$message.error('操作失败，请稍后再试！')
				})
			},
			getDate(val){
				this.formInline.startTime = timestampToTime(this.dateData[0]).substring(0, 10)
				this.formInline.endTime = timestampToTime(this.dateData[1]).substring(0, 10)
				this.getData()
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
				this.rechargeFormVisible = false
			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/prepayment/openAccount.vue